import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../shared/services/payment.service';
import { OpenSnackBarService } from '../../shared/services/snackBar.service';

@Component({
  selector: 'app-payment-handling',
  templateUrl: './payment-handling.component.html',
  styleUrls: ['./payment-handling.component.scss'],
  standalone: false
})
export class PaymentHandlingComponent implements OnInit {
  // tap_id=chg_TS07A4220250906w0XL1105375&
  redirect_target: string = '';
  constructor(private route: ActivatedRoute,
    private paymentService: PaymentService,
    private router: Router,
    private openSnackBarService: OpenSnackBarService,
  ) {
    this.route.queryParams.subscribe(params => {
      const tapId = params['tap_id'];
      this.redirect_target = localStorage.getItem('redirect_target');
      localStorage.removeItem('redirect_target');
      this.verifyPayment(tapId);
    });
  }

  ngOnInit() {
  }

  verifyPayment(tapId: string) {
    this.paymentService.verifyPayment(tapId).subscribe((response: any) => {
      if (response.status === 'CAPTURED') {
        this.openSnackBarService.openSnackBar(
          "success",
          "Payment successfully",
          "top"
        );
      } else {
        this.openSnackBarService.openSnackBar("fail", response.error);
      }
      this.router.navigate([this.redirect_target]);
    }
      , (error: any) => {
        // Handle error during payment verification
        this.openSnackBarService.openSnackBar("fail", error.error);
        this.router.navigate(['subscription']);
      });
  }
}
